<app-nav></app-nav>

<div class="menu-spacing">
    <app-inicio id="inicio"></app-inicio>
    <app-historia id="historia"></app-historia>
    <app-countdown id="countdown"></app-countdown>
    <app-rsvp id="rsvp"></app-rsvp>
    <app-presentes id="presentes"></app-presentes>
</div>